// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.frame-container[data-v-698e0fd8] {\n    position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
